'use client';

import {BetslipContextProvider} from "@/context/betslip.context";
import {AuthProvider} from "@/context/auth.context";
import {CookiesProvider} from "react-cookie";
import {HeaderProvider} from "@/context/header.context";
import {TrackingProvider} from "@/context/tracking.context";
import {LocationProvider} from "@/context/location.context";

export function Providers({children}: {children: any}) {
    return (
        <CookiesProvider>
            <AuthProvider>
                <TrackingProvider>
                    <BetslipContextProvider>
                        <HeaderProvider>
                            {children}
                        </HeaderProvider>
                    </BetslipContextProvider>
                </TrackingProvider>
            </AuthProvider>
        </CookiesProvider>
    )
}